import { useEffect, useState } from "react";
import StatusCircle from "./statusCircle";
import "./statusSection.css";
import { resolver } from "./../../API/middlewares/resolveRequests";
import { getProjectCount } from "../../API/store/actions/projects/projects";
import { useSelector } from "react-redux";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
const StatusSection = ({ tasksCount, isTask, communityId }) => {
  const userToken = useSelector((state) => state.login.userToken);
  // const [projectsCount, setProjectsCount] = useState(null);
  // useEffect(() => {
  //   resolver(getProjectCount, setProjectsCount, communityId, userToken);
  // }, [userToken, communityId]);
  return (
    <>
      <div
        style={{ backgroundColor: "#f2f2f2" }}
        className="d-flex align-items-center px-5 py-3 justify-content-center justify-content-lg-start"
      >
        {tasksCount && (
          <div className="col-9 col-lg-7 d-flex align-items-center justify-content-around">
            {tasksCount?.data?.total ? (
              <div>
                <div
                  style={{
                    border: "1px solid rgb(179, 179, 179)",
                    width: 80,
                    height: 80,
                    borderRadius: "50%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "white",
                    fontSize: 20,
                  }}
                >
                  {tasksCount?.data?.total ?? 0}
                </div>
                <div className="text-center pt-1">
                  {isTask
                    ? getDir(getCurrentLangFromRedux()) == "rtl"
                      ? "إجراء"
                      : "Procedure"
                    : getDir(getCurrentLangFromRedux()) == "rtl"
                    ? "مشروع"
                    : "Project"}
                </div>
              </div>
            ) : null}
            <StatusCircle
              title={
                `${tasksCount?.data?.bilateralcooperation} تعاون ثنائى `
                // isTask
                //   ? getDir(getCurrentLangFromRedux()) == "rtl"
                //     ? "إجراءات منتهية"
                //     : "Finished Procedures"
                //   : getDir(getCurrentLangFromRedux()) == "rtl"
                //   ? "مشاريع منتهية"
                //   : "Finished projects"
              }
              color="#00A349"
              precentage={
                tasksCount?.data?.total !== 0 &&
                tasksCount?.data?.total &&
                tasksCount?.data?.bilateralcooperation
                  ? Number(
                      (
                        (tasksCount?.data?.bilateralcooperation / tasksCount?.data?.total) *
                        100
                      ).toFixed(1)
                    )
                  : 0
              }
             
            />
            <StatusCircle
              title={
                `${tasksCount?.data?.conglomerate} تكتل`
                // isTask
                //   ? getDir(getCurrentLangFromRedux()) == "rtl"
                //     ? "إجراءات جارية"
                //     : "Current Procedures"
                //   : getDir(getCurrentLangFromRedux()) == "rtl"
                //   ? "مشاريع جارية"
                //   : "Current projects"
              }
              color="#0C4772"
              precentage={
                tasksCount?.data?.total != 0 &&
                tasksCount?.data?.total &&
                tasksCount?.data?.conglomerate
                  ?
                  Number(
                    (
                      (tasksCount?.data?.conglomerate / tasksCount?.data?.total) *
                      100
                    ).toFixed(1)
                  )
                    
                  : 0
              }
            />

            <StatusCircle
              title={
                `${tasksCount?.data?.multilateral} متعدد الأطراف `
                // isTask
                //   ? getDir(getCurrentLangFromRedux()) == "rtl"
                //     ? "إجراءات متأخرة"
                //     : "Late Procedureس"
                //   : getDir(getCurrentLangFromRedux()) == "rtl"
                //   ? "مشاريع متأخرة"
                //   : "Late projects"
              }
              precentage={
               tasksCount?.data?.total != 0 &&
                tasksCount?.data?.total &&
                tasksCount?.data?.multilateral
                  ? 
                  Number(
                    (
                      (tasksCount?.data?.multilateral / tasksCount?.data?.total) *
                      100
                    ).toFixed(1)
                  )
                    
                  : 0
              }
              color="#c21706"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default StatusSection;
